import React from 'react';
import { motion } from 'framer-motion';
const sectors = [{
  name: 'DeFi',
  change: 3.2
}, {
  name: 'Layer 1',
  change: -1.8
}, {
  name: 'Gaming',
  change: 5.1
}, {
  name: 'AI Tokens',
  change: 2.7
}, {
  name: 'Meme Coins',
  change: -4.2
}];
export function SectorPerformance() {
  return <div data-id="element-1362">
      <h2 className="text-sm font-heading text-text-primary mb-3" data-id="element-1363">
        Sector Performance
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3" data-id="element-1364">
        {sectors.map((sector, i) => <motion.div key={sector.name} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: i * 0.05
      }} className="glass-border rounded-xl p-3" data-id="element-1365">
            <div className="text-sm font-heading text-text-primary mb-1" data-id="element-1366">
              {sector.name}
            </div>
            <div className={`font-numbers text-lg font-light ${sector.change >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-1367">
              {sector.change >= 0 ? '+' : ''}
              {sector.change.toFixed(1)}%
            </div>
          </motion.div>)}
      </div>
    </div>;
}